import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router
} from 'react-router-dom';

import NewImportRequestView from './new_import_request_view';
import configureStore from './store';

export default class NewImportRequestPage extends React.Component {
  static propTypes = {
    database: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired,
    import: PropTypes.object,
    importRequest: PropTypes.object,
    paths: PropTypes.object.isRequired,
    sourceOptions: PropTypes.array.isRequired
  };

  baseUrl = () => {
    return this.props.paths.importRequest + '/import';
  };

  store = configureStore({
    form: {
      errors: null,
      importRequest: {
        ...this.props.importRequest,
        source: this.props.importRequest.source || 'other',
        customSourceName: this.props.importRequest.customSourceName || 'csv'
      }
    },
    importer: {
      import: this.props.import,
      currentFile: {},
      files: []
    },
    static: {
      database: this.props.database,
      paths: this.props.paths,
      sourceOptions: this.props.sourceOptions
    }
  });

  render() {
    return (
      <Router basename={this.baseUrl()}>
        <Provider store={this.store}>
          <NewImportRequestView />
        </Provider>
      </Router>
    );
  }
}
